import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Queue from './containers/queue';
import Position from './containers/position';
import Choose from './containers/choose';

export default function App() {
  return (
    <Router>
      <Switch>
        <Route exact path="/:organization/queues/:queue">
          <Choose />
        </Route>
        <Route exact path="/:organization/queues/:queue/admin">
          <Queue />
        </Route>
        <Route exact path="/:organization/queues/:queue/positions/:position">
          <Position />
        </Route>
      </Switch>
    </Router>
  );
}
